import { useNavigate } from "@tanstack/react-router";
import { useCallback } from "react";
import type { NavigateTarget } from "~/api/opsTypes";

/**
 * Open a navigate target by the `path` the server resolved (S3).
 *
 * The research route is `/research?research=<id>` — a query string, which the shell's
 * string-only `NavigateTo` (`router.navigate({ to })`) would treat as part of the pathname. The
 * router's `href` option parses pathname, search and hash together, so every kind of target
 * lands where the server said.
 */
export function useOpenTarget(): (target: Pick<NavigateTarget, "path">) => void {
  const navigate = useNavigate();
  return useCallback(
    (target: Pick<NavigateTarget, "path">) => {
      void navigate({ href: target.path });
    },
    [navigate],
  );
}
